import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  forgotPasswordRequest: ["email"],
  forgotPasswordSuccess: null,
  forgotPasswordFailure: null,
});

export const ForgotPasswordTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  success: null,
  error: null,
  payload: null,
  email: null,
});

export const ForgotPasswordSelectors = {
  getData: (state: any) => state.forgotPassword.data,
  isFetching: (state: any) => state.forgotPassword.fetching,
  isSuccess: (state: any) => state.forgotPassword.success,
  hasError: (state: any) => state.forgotPassword.error,
};

// request the data from an api
export const request = (state: any, { email }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    email,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// successful api lookup
export const success = (state: any, action: any) => {
  const updateData = {
    fetching: false,
    success: true,
    error: false,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// Something went wrong somewhere.
export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.FORGOT_PASSWORD_REQUEST]: request,
  [Types.FORGOT_PASSWORD_SUCCESS]: success,
  [Types.FORGOT_PASSWORD_FAILURE]: failure,
});
